import { render, staticRenderFns } from "./EditCategoryTemplateDialog.vue?vue&type=template&id=23307ec0&scoped=true"
import script from "./EditCategoryTemplateDialog.vue?vue&type=script&lang=js"
export * from "./EditCategoryTemplateDialog.vue?vue&type=script&lang=js"
import style0 from "./EditCategoryTemplateDialog.vue?vue&type=style&index=0&id=23307ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23307ec0",
  null
  
)

export default component.exports